// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"6ddbc874","787":"f92b752b"}[chunkId] + ".chunk.js";
};